import { render, staticRenderFns } from "./EditStep2.vue?vue&type=template&id=f95b0b96&scoped=true&"
import script from "./EditStep2.vue?vue&type=script&lang=js&"
export * from "./EditStep2.vue?vue&type=script&lang=js&"
import style0 from "./EditStep2.vue?vue&type=style&index=0&id=f95b0b96&prod&lang=css&"
import style1 from "./EditStep2.vue?vue&type=style&index=1&id=f95b0b96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b0b96",
  null
  
)

export default component.exports